import { IEirSalesAscertain } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAscertain";
import { IEirSalesAscertainResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesAscertainResponse";

export const mapEirSalesAscertain = (response: IEirSalesAscertainResponse): IEirSalesAscertain => ({
    reference: response.reference,
    offerId: response.offerId,
    hasActiveBroadband: response.activeBroadband ?? response.hasActiveBroadband ?? false,
    keepMobileNumber: response.keepMobileNumber,
    provisionBroadband: response.provisionBroadband ?? response.provisioningBroadbandOrderType ?? "",
    provisionVobb: response.provisionVobb,
    appointmentType: response.appointmentType,
    acquisitionType: response.acquisitionType,
    broadbandAccountNumber: response.broadbandAccountNumber ?? undefined,
    broadbandServiceDetails: response.broadbandServiceDetails,
    fixedServiceDetails: response.fixedServiceDetails,
});
